import React from 'react';
import './PetAnimations.css';

export default function HermitCrabSvg({ size = 120, color, className = '' }) {
  const shellColor = color || '#D9A86C';
  const shellLight = '#F3D7A6';
  const shellDark = '#9B6E3E';
  const crabColor = '#E86A55';
  const crabDark = '#B84432';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Sandy ground */}
      <ellipse cx="60" cy="104" rx="36" ry="5" fill="#EFD9A7" opacity="0.6" />
      {/* Left claw peeking out */}
      <ellipse cx="34" cy="78" rx="6" ry="5" fill={crabColor} transform="rotate(-20 34 78)" />
      <path d="M28 76L24 72L26 78L24 82Z" fill={crabColor} />
      <path d="M28 76L26 78" stroke={crabDark} strokeWidth="1" strokeLinecap="round" />
      {/* Right claw peeking out */}
      <ellipse cx="86" cy="78" rx="6" ry="5" fill={crabColor} transform="rotate(20 86 78)" />
      <path d="M92 76L96 72L94 78L96 82Z" fill={crabColor} />
      <path d="M92 76L94 78" stroke={crabDark} strokeWidth="1" strokeLinecap="round" />
      {/* Little legs */}
      <path d="M44 96L40 102" stroke={crabColor} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M52 98L50 104" stroke={crabColor} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M76 96L80 102" stroke={crabColor} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M68 98L70 104" stroke={crabColor} strokeWidth="2.5" strokeLinecap="round" />
      {/* Shell base (big spiral) */}
      <circle cx="60" cy="62" r="32" fill={shellColor} />
      <circle cx="60" cy="62" r="32" fill="none" stroke={shellDark} strokeWidth="1.5" />
      {/* Spiral coils */}
      <path
        d="M60 62 m -22 0 a 22 22 0 1 1 44 0 a 22 22 0 1 1 -44 0 M60 62 m -14 0 a 14 14 0 1 1 28 0 a 14 14 0 1 1 -28 0 M60 62 m -7 0 a 7 7 0 1 1 14 0 a 7 7 0 1 1 -14 0"
        stroke={shellDark}
        strokeWidth="1.5"
        fill="none"
      />
      {/* Shell highlight */}
      <ellipse cx="50" cy="50" rx="10" ry="7" fill={shellLight} opacity="0.5" />
      {/* Crab face inside shell */}
      <ellipse cx="60" cy="68" rx="12" ry="9" fill={crabColor} />
      {/* Eye stalks */}
      <path d="M54 60L52 50" stroke={crabColor} strokeWidth="2" strokeLinecap="round" />
      <path d="M66 60L68 50" stroke={crabColor} strokeWidth="2" strokeLinecap="round" />
      <circle cx="52" cy="48" r="3" fill="white" />
      <circle cx="68" cy="48" r="3" fill="white" />
      <circle cx="52" cy="48" r="1.5" fill="#2C2419" />
      <circle cx="68" cy="48" r="1.5" fill="#2C2419" />
      {/* Smile */}
      <path d="M56 70C58 72 62 72 64 70" stroke={crabDark} strokeWidth="1" strokeLinecap="round" fill="none" />
    </svg>
  );
}
